module.exports = __webpack_public_path__ + "static/img/047_TO8_1569.b293d17.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/047_TO8_1569.jpg
// module id = GZOW
// module chunks = 0